import _ from 'lodash';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { Button, Modal } from 'semantic-ui-react';

/**
 * Returns an object consisting of props beyond the scope of the Component.
 * Useful for getting and spreading unknown props from the user.
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @returns {{}} A shallow copy of the prop object
 */
const getUnhandledProps = (Component, props) => {
  // Note that `handledProps` are generated automatically during build with `babel-plugin-transform-react-handled-props`
  const { handledProps = [] } = Component;

  return Object.keys(props).reduce((acc, prop) => {
    // "childKey" and "innerRef" are internal props of Semantic UI React
    // "innerRef" can be removed when "Search" & "Dropdown components will be removed to be functional
    if (prop === 'childKey' || prop === 'innerRef') return acc;
    if (handledProps.indexOf(prop) === -1) acc[prop] = props[prop];
    return acc;
  }, {});
};

export const IntegrityAlert = React.forwardRef(function (props, ref) {
  const {
    cancelButton = 'Cancel',
    confirmButton = 'Delete anyway',
    content = 'Wird referenziert von Rezepten. Möchten Sie fortfahren?',
    references,
    header,
    open,
    size = 'small',
  } = props;
  const rest = getUnhandledProps(IntegrityAlert, props);

  const handleCancel = (e) => {
    _.invoke(props, 'onCancel', e, props);
  };

  const handleCancelOverrides = (predefinedProps) => ({
    onClick: (e, buttonProps) => {
      _.invoke(predefinedProps, 'onClick', e, buttonProps);
      handleCancel(e);
    },
  });

  const handleConfirmOverrides = (predefinedProps) => ({
    onClick: (e, buttonProps) => {
      _.invoke(predefinedProps, 'onClick', e, buttonProps);
      _.invoke(props, 'onConfirm', e, props);
    },
  });

  // `open` is auto controlled by the Modal
  // It cannot be present (even undefined) with `defaultOpen`
  // only apply it if the user provided an open prop
  const openProp = {};
  if (_.has(props, 'open')) {
    openProp.open = open;
  }
  return (
    <Modal {...rest} {...openProp} size={size} onClose={handleCancel} ref={ref}>
      {Modal.Header.create(header, { autoGenerateKey: false })}
      <Modal.Content>
        <p>{content}</p>
        <p>
          <ul>
            {(references || []).map((reference, index) => (
              <li key={index}>
                <Link
                  to={`/controlpanel/rezeptdatenbank/rezepte/details?id=${reference.rezept_id}`}
                  target="_blank"
                >
                  {reference.rezept_name}
                </Link>
              </li>
            ))}
          </ul>
        </p>
      </Modal.Content>
      <Modal.Actions>
        {Button.create(confirmButton, {
          autoGenerateKey: false,
          overrideProps: handleConfirmOverrides,
          primary: true,
          onClick: (e) => {
            _.invoke(props, 'onConfirm', e, props);
          },
        })}
        {Button.create(cancelButton, {
          autoGenerateKey: false,
          overrideProps: handleCancelOverrides,
        })}
      </Modal.Actions>
    </Modal>
  );
});
